import ErrorHandler from '@/ErrorHandler';
import GlobalEventBus from '@/GlobalEventBus';
import GlobalEvents from '@/GlobalEvents';
import API from '@/org-app/api';
import {
  createDeleteAction,
  createGetAllAction,
  createGetOneAction,
  createPatchAction,
  createPostAction,
  createPutAction,
} from '@/utils/ActionsUtils';
import i18n from '@/vueI18n';

import * as types from './mutation-types';

const actions = {
  getUnitPacks: createGetAllAction(
    API.instance.getUnitPacks,
    types.UPDATE_UNIT_PACKS_LIST,
    'messages.failedToGetUnitPacks',
    true,
  ),
  getUnitPack: createGetOneAction(
    API.instance.getUnitPack,
    types.UPDATE_UNIT_PACK,
    'messages.failedToGetUnitPacks',
    true,
  ),
  createUnitPack: createPostAction(API.instance.postUnitPack, types.SAVE_UNIT_PACK, 'messages.failedToCreateUnitPack'),
  updateUnitPack: createPutAction(API.instance.putUnitPack, types.SAVE_UNIT_PACK, 'messages.failedToUpdateUnitPack'),
  deleteUnitPack: createDeleteAction(
    API.instance.deleteUnitPack,
    types.DELETE_UNIT_PACK,
    'messages.failedToDeleteUnitPacks',
  ),
  patchUnitPacks: createPatchAction(API.instance.patchUnitPacks),

  getUnitPackInventoryTargeting({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.instance.getUnitPackInventoryTargeting(params, resolve, (error) => {
        const msg = i18n.global.t('messages.failedToGetUnitPack');
        ErrorHandler.showError(msg, error);
        reject(new Error('Failed to get unit pack targeting'));
      });
    });
  },

  createUnitPackInventoryTargeting({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.instance.createUnitPackInventoryTargeting(params, resolve, (error) => {
        const msg = i18n.global.t('messages.failedToCreateUnitPack');
        ErrorHandler.showError(msg, error);
        reject(new Error('Failed to create unit pack targeting'));
      });
    });
  },

  updateUnitPackInventoryTargeting({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.instance.updateUnitPackInventoryTargeting(params, resolve, (error) => {
        const msg = i18n.global.t('messages.failedToUpdateUnitPack');
        ErrorHandler.showError(msg, error);
        reject(new Error('Failed to update unit pack targeting'));
      });
    });
  },

  unitPackUpdateUnits({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.instance.unitPackUpdateUnits(params, resolve, (error) => {
        const msg = i18n.global.t('messages.failedToUpdateUnitPack');
        ErrorHandler.showError(msg, error);
        reject(new Error('Failed to update units in unit pack'));
      });
    });
  },

  getUnitsInUnitPack({ commit }, { queryParams }) {
    return new Promise((resolve, reject) => {
      API.instance.getUnitsInUnitPack(
        queryParams,
        (response) => {
          resolve(response);
        },
        (error) => {
          const msg = 'FAIL';
          ErrorHandler.showError(msg, error);
          reject(new Error('Failed to get units in unit pack'));
        },
      );
    });
  },

  async saveUnitsInUnitPack({ commit }, { id, data }) {
    return API.instance
      .postUnitsInUnitPack({
        id,
        data,
      })
      .catch((err) => {
        const msg = i18n.global.t('messages.failedToSaveUnitsInUnitPack');
        ErrorHandler.showError(msg, err);
        GlobalEventBus.$emit(GlobalEvents.loaded);
        throw err;
      });
  },
};

export default actions;
